import React, { useRef } from 'react';

interface FileInputProps {
  onFileLoad: (file: File) => void;
}

export const FileInput: React.FC<FileInputProps> = ({ onFileLoad }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileLoad(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <input
 ref={fileInputRef}
 type="file"
 accept=".eir,.yaml,.yml"
 onChange={handleFileChange}
 style={{ display: 'none' }}
 />
      <button onClick={triggerFileInput} style={{ display: 'none' }}>
        Hidden File Input Trigger
      </button>
    </>
  );
};
